import React from 'react';

const SubDistrictsTable = ({ subDistricts, onRowClick, onEdit, onDelete }) => {
    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            {/* Desktop Table View */}
            <div className="hidden md:block overflow-x-auto">
                <table className="w-full">
                    <thead>
                        <tr className="bg-gray-50 border-b border-gray-200">
                            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Sub-District Name</th>
                            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">District</th>
                            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Clubs Count</th>
                            <th className="px-6 py-4 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {subDistricts.map((sd) => (
                            <tr
                                key={sd.id}
                                className="hover:bg-blue-50 transition-colors cursor-pointer group"
                                onClick={() => onRowClick && onRowClick(sd)}
                            >
                                <td className="px-6 py-4 text-sm font-medium text-gray-900 group-hover:text-blue-600">{sd.name}</td>
                                <td className="px-6 py-4 text-sm text-gray-600">{sd.district_name}</td>
                                <td className="px-6 py-4 text-sm text-gray-600">{sd.club_count}</td>
                                <td className="px-6 py-4 text-right">
                                    <div className="flex justify-end gap-3" onClick={(e) => e.stopPropagation()}>
                                        <button
                                            onClick={() => onEdit(sd)}
                                            className="text-blue-600 hover:text-blue-800 text-sm font-medium transition-colors"
                                        >
                                            Edit
                                        </button>
                                        <button
                                            onClick={() => onDelete(sd.id)}
                                            className="text-red-500 hover:text-red-700 text-sm font-medium transition-colors"
                                        >
                                            Delete
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Mobile Grid View */}
            <div className="md:hidden divide-y divide-gray-100">
                {subDistricts.map((sd) => (
                    <div
                        key={sd.id}
                        className="p-4 space-y-3 active:bg-blue-50 transition-colors"
                        onClick={() => onRowClick && onRowClick(sd)}
                    >
                        <div className="flex justify-between items-start">
                            <div>
                                <div className="font-bold text-gray-900 text-lg">{sd.name}</div>
                                <div className="text-xs text-gray-500 font-medium">District: {sd.district_name}</div>
                            </div>
                            <div className="bg-blue-50 px-3 py-1 rounded-lg text-center">
                                <div className="text-[10px] font-black text-blue-400 uppercase tracking-tighter">Clubs</div>
                                <div className="text-sm font-black text-blue-900">{sd.club_count}</div>
                            </div>
                        </div>
                        <div className="flex justify-end gap-3 pt-2 border-t border-gray-50" onClick={(e) => e.stopPropagation()}>
                            <button
                                onClick={() => onEdit(sd)}
                                className="px-3 py-1.5 bg-blue-50 text-blue-600 rounded-lg text-xs font-bold uppercase"
                            >
                                Edit
                            </button>
                            <button
                                onClick={() => onDelete(sd.id)}
                                className="px-3 py-1.5 bg-red-50 text-red-500 rounded-lg text-xs font-bold uppercase"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SubDistrictsTable;
